import Login from '@/components/Login.vue'
import HomeGia from '@/components/HomeGia.vue'
import HomeAdmin from '@/components/HomeAdmin.vue'
import HomeTPA from '@/components/HomeTPA.vue'
import HomeIRGE from '@/components/HomeIRGE.vue'
import HomeCorp from '@/components/HomeCorp.vue'
import Landing from '@/components/landing_Componentes/Landing.vue'

// SCA v2.0.0 Documentacion IRGE

import HomeDocumentacionIRGE from '@/components/sca_Componentes/irge/HomeDocumentacion.vue'
import DocumentarIrge from '@/components/sca_Componentes/irge/Documentar_IRGE.vue'
import BusquedasIrge from '@/components/sca_Componentes/irge/Busquedas_IRGE.vue'
import ReportesIrge from '@/components/sca_Componentes/irge/Reportes_IRGE.vue'
import ConfiguracionIrge from '@/components/sca_Componentes/irge/Configuracion_IRGE.vue'
import EditarEmbarqueIrge from '@/components/sca_Componentes/irge/EditarEmbarque.vue'
import EntradasIrge from '@/components/sca_Componentes/irge/EntradasIrge.vue'

// SCA v2.0.0 Documentacion TPA

import HomeDocumentacionTPA from '@/components/sca_Componentes/tpa/HomeDocumentacion.vue'
//import HomeDocumentacionTPA from '@/components/sca_Componentes/tpa/HomeSCA_TPA.vue'
import DocumentarTpa from '@/components/sca_Componentes/tpa/Documentar_TPA.vue'
import BusquedasTpa from '@/components/sca_Componentes/tpa/Busquedas_TPA.vue'
import ReportesTpa from '@/components/sca_Componentes/tpa/Reportes_TPA.vue'
import ConfiguracionTpa from '@/components/sca_Componentes/tpa/Configuracion_TPA.vue'
import EditarEmbarqueTpa from '@/components/sca_Componentes/tpa/EditarEmbarque.vue'
import EntradasTpa from '@/components/sca_Componentes/tpa/EntradasTPA.vue'

//Accesos IRGE
import Accesos_IRGE from '@/components/sca_Componentes/acceso/HomeAccesos.vue'
import NuevaLlegada_IRGE from '@/components/sca_Componentes/acceso/NuevaLlegada.vue'
import EditarAcceso_IRGE from '@/components/sca_Componentes/acceso/EditarAcceso.vue'

//Autotanques
import Autotanques_IRGE from '@/components/sca_Componentes/acceso/Autotanques.vue'

import Salida_IRGE from '@/components/sca_Componentes/acceso/Salida.vue'
import Puntos_IRGE from '@/components/sca_Componentes/acceso/Puntos.vue'
import FirmaPuntos_IRGE from '@/components/sca_Componentes/acceso/FirmaPuntos.vue'
import BusquedaPG_IRGE from '@/components/sca_Componentes/acceso/BusquedaPG.vue'
import Agregar_IRGE from '@/components/sca_Componentes/acceso/Agregar.vue'
import Lista_IRGE from '@/components/sca_Componentes/acceso/ListaVerificacion.vue'
import Emplazados_IRGE from '@/components/sca_Componentes/acceso/Emplazados.vue'

// Inventario
import Articulos from '@/components/inventario_Componentes/Articulos.vue'
import SubMenu from '@/components/inventario_Componentes/SubMenu.vue'
import MenuAlmacen from '@/components/inventario_Componentes/MenuAlmacen.vue'
import SubMenuEntradas from '@/components/inventario_Componentes/SubMenuEntradas.vue'
import SubMenuSalidas from '@/components/inventario_Componentes/SubMenuSalidas.vue'
import SubMenuAlmacen from '@/components/inventario_Componentes/SubMenuAlmacen.vue'
import Busqueda from '@/components/inventario_Componentes/Busqueda.vue'
import BusquedaSalidas from '@/components/inventario_Componentes/BusquedaSalidas.vue'
import BusquedaAvanzada from '@/components/inventario_Componentes/BusquedaAvanzada.vue'
import ArticuloDetalle from '@/components/inventario_Componentes/ArticuloDetalle.vue'
import Altas from '@/components/inventario_Componentes/Altas.vue'
import AltaNueva from '@/components/inventario_Componentes/AltaNueva.vue'
import AltaDetalle from '@/components/inventario_Componentes/AltaDetalle.vue'
import NuevaAsignacion from '@/components/inventario_Componentes/NuevaAsignacion.vue'
import NuevoPrestamo from '@/components/inventario_Componentes/NuevoPrestamo.vue'
import Tipos from '@/components/inventario_Componentes/Tipos.vue'
import Marcas from '@/components/inventario_Componentes/Marcas.vue'
import Tags from '@/components/inventario_Componentes/Tags.vue'
import Historia from '@/components/inventario_Componentes/Historia.vue'
import Resguardos from '@/components/inventario_Componentes/Resguardos.vue'
import Empleados from '@/components/inventario_Componentes/Empleados.vue'
import SalidasInv from '@/components/inventario_Componentes/SalidasInv.vue'
import SalidaNueva from '@/components/inventario_Componentes/SalidaNueva.vue'
import Asignaciones from '@/components/inventario_Componentes/Asignaciones.vue'
import AsignacionDetalle from '@/components/inventario_Componentes/AsignacionDetalle.vue'
import FirmarAsignacion from '@/components/inventario_Componentes/FirmarAsignacion.vue'
import FirmarPrestamo from '@/components/inventario_Componentes/FirmarPrestamo.vue'
import SalidaDetalle from '@/components/inventario_Componentes/SalidaDetalle.vue'
import FirmarSalida from '@/components/inventario_Componentes/FirmarSalida.vue'
import ListaSalida from '@/components/inventario_Componentes/ListaSalida.vue'
import Consumibles from '@/components/inventario_Componentes/Consumibles.vue'
import NuevoArticulo from '@/components/inventario_Componentes/NuevoArticulo.vue'
import NuevaFactura from '@/components/inventario_Componentes/NuevaFactura.vue'
import NuevoConsumible from '@/components/inventario_Componentes/NuevoConsumible.vue'
import UpdateConsumible from '@/components/inventario_Componentes/UpdateConsumible.vue'
import ConsumiblesFirmar from '@/components/inventario_Componentes/FirmarSalidaCons.vue'
import ContainerSalida_Cons from '@/components/inventario_Componentes/ContainerSalida_Cons.vue'
import ContainerReingreso_Cons from '@/components/inventario_Componentes/ContainerReingreso_Cons.vue'
import ConsumibleDetalle from '@/components/inventario_Componentes/ConsumibleDetalle.vue'
import Menu from '@/components/inventario_Componentes/Menu.vue'
import SubMenuAsignaciones from '@/components/inventario_Componentes/SubMenuAsignaciones.vue'
import Prestamos from '@/components/inventario_Componentes/Prestamos.vue'
import PrestamoDetalle from '@/components/inventario_Componentes/PrestamoDetalle.vue'
import SubMenuAdmon from '@/components/inventario_Componentes/SubMenuAdmon.vue'
import HistoriaNumero from '@/components/inventario_Componentes/HistoriaNumero.vue'
import DescargasAsinaciones from '@/components/inventario_Componentes/DescargasAsignaciones.vue'
import ContainerMaquinaria from '@/components/inventario_Componentes/ContainerMaquinaria.vue'
import SubMenuSistemas from '@/components/inventario_Componentes/SubMenuSistemas.vue'
import ContainerAlmacenes from '@/components/inventario_Componentes/ContainerAlmacenes.vue'
import ListaArticulos from '@/components/inventario_Componentes/ListaArticulos.vue'
import ContainerConsumibles from '@/components/inventario_Componentes/ContainerConsumibles.vue'
import ListaArticulosCede from '@/components/inventario_Componentes/ListaArticulosCede.vue'
import Traspasos from '@/components/inventario_Componentes/Traspasos.vue'
import ListaAlmacenes from '@/components/inventario_Componentes/ListaAlmacenes.vue'
import ListaAsignaciones from '@/components/inventario_Componentes/ListaAsignaciones.vue'
import ListaPrestamos from '@/components/inventario_Componentes/ListaPrestamos.vue'
import BajaArticulo from '@/components/inventario_Componentes/BajaArticulo.vue'
import FirmarBaja from '@/components/inventario_Componentes/FirmarBaja.vue'
import Bajas from '@/components/inventario_Componentes/Bajas.vue'

//Facturas Asistentes
import FacturasAsistentes from '@/components/asistentes_Componentes/facturas/FacturasAsistentes.vue'

//FirmarBaja
import ConsumiblesCedes from '@/components/inventario_Componentes/cedes/Consumibles.vue'

// Reasignaciones
import Reasignaciones from '@/components/inventario_Componentes/Reasignaciones.vue'
import NewReasignacion from '@/components/inventario_Componentes/NewReasignacion.vue'
import Reasignar from '@/components/inventario_Componentes/Reasignar.vue'


// Directorio
import Directorio from '@/components/directorio_Componentes/HomeDirectorio.vue'

// Soporte
import Soporte from '@/components/soporte_Componentes/Soporte.vue'
import NuevoTicket from '@/components/soporte_Componentes/NuevoTicket.vue'
import DetalleTicket from '@/components/soporte_Componentes/DetalleTicket.vue'
import AtenderTicket from '@/components/soporte_Componentes/Atender.vue'

// Estaciones
import Estacion from '@/components/HomeEstaciones.vue'
import Monitor from '@/components/estaciones_Componentes/Monitor.vue'
import valvulas from '@/components/estaciones_Componentes/Valvulas.vue'
import Reportes from '@/components/estaciones_Componentes/Reportes.vue'

// Externos
import HomeGrupos from '@/components/HomeGrupos.vue'
import NewFacturaTPA from '@/components/grupos_Componentes/TPA/NewFactura.vue'
import FacturasTPA from '@/components/grupos_Componentes/TPA/Facturas.vue'
import CargasGruposTPA from '@/components/grupos_Componentes/TPA/CargasGrupos.vue'
import NewFacturaIRGE from '@/components/grupos_Componentes/IRGE/NewFacturaIRGE.vue'
import FacturasIRGE from '@/components/grupos_Componentes/IRGE/FacturasIRGE.vue'
import CargasGruposIRGE from '@/components/grupos_Componentes/IRGE/CargasGruposIRGE.vue'

// Planificación
import HomePlanificacion from '@/components/planificacion_Componentes/HomePlanificacion.vue'

// Resumen
import HomeResumen from '@/components/resumen_Componentes/HomeResumen.vue'

// Checklist
import HomeChecklist from '@/components/checklist_Componentes/HomeChecklist.vue'
import Historia_Checklist from '@/components/checklist_Componentes/Historia.vue'

// Solicitudes
import HomeSolicitudes from '@/components/solicitudes_Componentes/HomeSolicitudes.vue'
import NuevaSolicitud from '@/components/solicitudes_Componentes/NuevaSolicitud.vue'

//Usuarios
import HomeUsuarios from '@/components/usuarios_Componentes/HomeUsuarios.vue'
import UsuarioNuevo from '@/components/usuarios_Componentes/usuario_Nuevo.vue'
import UsuarioDetalle from '@/components/usuarios_Componentes/usuario_Detalle.vue'
import Permisos from '@/components/usuarios_Componentes/Permisos.vue'
import PermisosNuevos from '@/components/usuarios_Componentes/PermisosNuevos.vue'

//Passwords
import GeneradorPasswords from '@/components/passwords_Componentes/GeneradorPasswords.vue'

//Requisiciones
import Requisiciones from '@/components/requisiciones_Componentes/Requisiciones.vue'
import RequisicionNueva from '@/components/requisiciones_Componentes/RequisicionNueva.vue'
import RequisicionEditar from '@/components/requisiciones_Componentes/RequisicionEditar.vue'
import FormFirma from '@/components/requisiciones_Componentes/FormFirma.vue'
import Proveedores from '@/components/requisiciones_Componentes/Proveedores.vue'
import NuevoProveedor from '@/components/requisiciones_Componentes/NuevoProveedor.vue'
import BaseArticulos from '@/components/requisiciones_Componentes/BaseArticulos.vue'
import NuevoArticulo_Base from '@/components/requisiciones_Componentes/NuevoArticulo_Base.vue'
import HomeComprasReq from '@/components/requisiciones_Componentes/Home.vue'
import MenuComprasReq from '@/components/requisiciones_Componentes/MenuComprasReq.vue'
import HomeCajaChica from '@/components/requisiciones_Componentes/CajaChica_Componentes/HomeCajaChica.vue'
import HomePartidaNoPres from '@/components/requisiciones_Componentes/PartidaNoPres_Componentes/HomePartidaNoPres.vue'

// Cotizaciones
import HomeCotizaciones from '@/components/cotizaciones_Componentes/HomeCotizaciones.vue'
import CotizacionNueva from '@/components/cotizaciones_Componentes/CotizacionNueva.vue'

// Presupuestos
import HomePresupuestos from '@/components/presupuestos_Componentes/HomePresupuestos.vue'
import PresupuestoNuevo from '@/components/presupuestos_Componentes/PresupuestoNuevo.vue'

//Responsivas
import Responsivas from '@/components/responsivas_Componentes/Responsivas.vue'
import NuevaResponsiva from '@/components/responsivas_Componentes/NuevaResponsiva.vue'
import FirmaResponsiva from '@/components/responsivas_Componentes/FirmaResponsiva.vue'
import EditarResponsiva from '@/components/responsivas_Componentes/EditarResponsiva.vue'


// Combustibles
import Combu_Saldo from '@/components/combustibles_Componentes/SaldoTarjetas.vue'
import Combu_Asignaciones from '@/components/combustibles_Componentes/Asignaciones.vue'
import Combu_Salidas from '@/components/combustibles_Componentes/Salidas.vue'
import Combu_NewAsignacion from '@/components/combustibles_Componentes/NewAsignacion.vue'
import Combu_NewTraspaso from '@/components/combustibles_Componentes/NewTraspaso.vue'
import Combu_NewSalida from '@/components/combustibles_Componentes/NewSalida.vue'
import Combu_Resumen from '@/components/combustibles_Componentes/Resumen.vue'
import Combu_NewResumen from '@/components/combustibles_Componentes/NewResumen.vue'
import Combu_FirmaReporteMensual from '@/components/combustibles_Componentes/FirmarReporteMensual.vue'
import Combu_EditarSalida from '@/components/combustibles_Componentes/EditarSalida.vue'
import Combu_NuevoVehiculo from '@/components/combustibles_Componentes/NuevoVehiculo.vue'
import Combu_Traspasos from '@/components/combustibles_Componentes/Traspasos.vue'
import TarjetasMovimientos from '@/components/combustibles_Componentes/TarjetasMovimientos.vue'
import Combu_TarjetasNuevo from '@/components/combustibles_Componentes/NewMovimientoTarjeta.vue'
import HomeTransportes from '@/components/combustibles_Componentes/HomeTransportes.vue'
import HomeCombustibles from '@/components/combustibles_Componentes/HomeCombustibles.vue'
import HomeTarjetas from '@/components/combustibles_Componentes/HomeTarjetas.vue'
import HomeTags from '@/components/combustibles_Componentes/HomeTags.vue'
import HomeVehiculos from '@/components/combustibles_Componentes/HomeVehiculos.vue'
import Vehiculo_Unidades from '@/components/combustibles_Componentes/Vehiculos.vue'
import TagsMovimientos from '@/components/combustibles_Componentes/TagsMovimientos.vue'
import NewMovimientoTag from '@/components/combustibles_Componentes/NewMovimientoTag.vue'
import TarjetasComercios from '@/components/combustibles_Componentes/comercios/Comercios.vue'
import ComercioNuevo from '@/components/combustibles_Componentes/comercios/NuevoComercio.vue'
import TagsCruces from '@/components/combustibles_Componentes/cruces/Cruces.vue'
import CruceNuevo from '@/components/combustibles_Componentes/cruces/NuevoCruce.vue'
import ImportarTags from '@/components/combustibles_Componentes/ImportarTags.vue'
import ImportarTarjetas from '@/components/combustibles_Componentes/ImportarTarjetas.vue'

// Documentación
import  HomeDocumentacionApp from '@/components/documentacion_Componentes/Home_documentacion.vue'

// Aplicaciones administrativas
import HomeGA from '@/components/HomeGA.vue'
import HomeDucto from '@/components/HomeDucto.vue'
import HomeGIA_S from '@/components/HomeGIA_S.vue'
import HomeGIA_A from '@/components/HomeGIA_A.vue'
import HomeAsistentes from '@/components/HomeAsistentes.vue'
import HomeAuditoria from '@/components/HomeAuditoria.vue'

// Codigos QR
import CodigosQR_Home from '@/components/codigosQR_Componentes/Home.vue'
import CodigosQR_Registro from '@/components/codigosQR_Componentes/Registro.vue'

// Proveedores Pendientes
import ProveedoresPendientes from '@/components/inventario_Componentes/ProveedoresPendientes.vue'
import ProveedoresPendientesEditar from '@/components/inventario_Componentes/ProveedoresPendientesEditar.vue'

// IRGE
import MenuIRGE from '@/components/irge_components/Menu.vue'

// TPA
import MenuTPA from '@/components/tpa_components/Menu.vue'

// IRGE Nominaciones
import HomeNominacionesIRGE from '@/components/sca_Componentes/irge/nominaciones/HomeNominaciones.vue'

// IRGE CuartoControl
import HomeCuartoControlIRGE from '@/components/sca_Componentes/irge/cuartocontrol/HomeCuartoControl.vue'

// IRGE Accesos
import HomeAccesosIRGE from '@/components/sca_Componentes/irge/accesos/HomeAccesos.vue'
import NuevoAccesosIRGE from '@/components/sca_Componentes/irge/accesos/NuevoAcceso.vue'
import UpdateAccesosIRGE from '@/components/sca_Componentes/irge/accesos/EditAccesos.vue'

// BASCULA
import BasculaIRGE from '@/components/sca_Componentes/irge/cuartocontrol/Bascula.vue'

// BITACORA
import BitacoraIRGE from '@/components/sca_Componentes/irge/Bitacora.vue'

// DASHBOARD
import DashboardIRGE from '@/components/sca_Componentes/irge/dashboard/Home.vue'

// CONSUMOS
import ConsumosIRGE from '@/components/sca_Componentes/irge/cuartocontrol/Consumos.vue'

// TPA Nominaciones
import HomeNominacionesTPA from '@/components/sca_Componentes/tpa/nominaciones/HomeNominaciones.vue'

// TPA CuartoControl
import HomeCuartoControlTPA from '@/components/sca_Componentes/tpa/cuartocontrol/HomeCuartoControl.vue'

// TPA Accesos
import HomeAccesosTPA from '@/components/sca_Componentes/tpa/accesos/HomeAccesos.vue'
import NuevoAccesosTPA from '@/components/sca_Componentes/tpa/accesos/NuevoAcceso.vue'
import UpdateAccesosTPA from '@/components/sca_Componentes/tpa/accesos/EditAccesos.vue'

// TPA BASCULA
import BasculaTPA from '@/components/sca_Componentes/tpa/cuartocontrol/Bascula.vue'

// TPA BITACORA
import BitacoraTPA from '@/components/sca_Componentes/tpa/Bitacora.vue'

// TPA DASHBOARD
import DashboardTPA from '@/components/sca_Componentes/tpa/dashboard/Home.vue'

// TPA CONSUMOS
import ConsumosTPA from '@/components/sca_Componentes/tpa/cuartocontrol/Consumos.vue'

//TPA GESTION DE GRUPOS Y SUBGRUPOS
import GruposTPA from '@/components/sca_Componentes/tpa/cuartocontrol/gestionGrupos.vue'
import SubgrupoTPA from '@/components/sca_Componentes/tpa/cuartocontrol/Subgrupos.vue'
import EditarSubgrupoTPA from '@/components/sca_Componentes/tpa/cuartocontrol/EditarSubgrupo.vue'
import GruposIRGE from '@/components/sca_Componentes/irge/cuartocontrol/gestionGrupos.vue'
import SubgrupoIRGE from '@/components/sca_Componentes/irge/cuartocontrol/Subgrupos.vue'
import EditarSubgrupoIRGE from '@/components/sca_Componentes/irge/cuartocontrol/EditarSubgrupo.vue'

// ASISTENCIAS
import VisitasCorpoHome from '@/components/visitas_Componentes/HomeVisitas.vue'
import VisitasCorpo from '@/components/visitas_Componentes/Visitas.vue'
import VisitasCorpoRegistrar from '@/components/visitas_Componentes/NuevaVisita.vue'
import VisitasCorpoFirmar from '@/components/visitas_Componentes/FirmaVisita.vue'
import VisitasCorpoReportes from '@/components/visitas_Componentes/ReportesVisitas.vue'

// Apartados
import ApartadoActivos from '@/components/apartados/ApartadoActivos.vue'
import ApartadoAuditoria from '@/components/apartados/ApartadoAuditoria.vue'
import ApartadoDucto from '@/components/apartados/ApartadoDucto.vue'
import ApartadoGIA from '@/components/apartados/ApartadoGIA.vue'
import ApartadoIRGE from '@/components/apartados/ApartadoIRGE.vue'
import ApartadoTPA from '@/components/apartados/ApartadoTPA.vue'
import ApartadoCORPO from '@/components/apartados/ApartadoCORPO.vue'
import ApartadoRH from '@/components/apartados/ApartadoRH.vue'

// Busqueda
import Buscar from '@/components/inventario_Componentes/Buscar.vue'

// DucterTube
import DucterTube from '@/components/DucterTube.vue'
import DucterTube_Nuevo from '@/components/ducterTube/views/nuevo.vue'

// ConsultaHistoricas
import ConsultaHistorica from '@/components/sca_Componentes/monitor/ConsultaHistorica.vue'
import ListadoConsultaHistorica from '@/components/sca_Componentes/monitor/ListadoConsultaHistorica.vue'
import ListadoArchivos from '@/components/sca_Componentes/monitor/ListadoArchivos.vue'

import ExpedienteDescarga from '@/components/sca_Componentes/monitor/ExpedienteDescarga.vue'

//SASISOPA
import ApartadoSASISOPA from '@/components/apartados/ApartadoSASISOPA.vue'
import AddTerminalSASISOPA from '@/components/sasisopa/AddTerminalSASISOPA.vue'
import EditTerminalSASISOPA from '@/components/sasisopa/EditTerminalSASISOPA.vue'
import DocumentsSASISOPA from '@/components/sasisopa/DocumentsSASISOPA.vue'
import EditDocumentSASISOPA from '@/components/sasisopa/EditDocumentSASISOPA.vue'
import EditAmbitSASISOPA from '@/components/sasisopa/EditAmbitSASISOPA.vue'
import AddDocumentSASISOPA from '@/components/sasisopa/AddDocumentSASISOPA.vue'
import AmbitSASISOPA from '@/components/sasisopa/AmbitSASISOPA.vue'
import AddAmbitSASISOPA from '@/components/sasisopa/AddAmbitSASISOPA.vue'
import FilesSASISOPA from '@/components/sasisopa/FilesSASISOPA.vue'
import FileSASISOPA from '@/components/sasisopa/FileSASISOPA.vue'
import logs from '@/components/sasisopa/logs.vue'
import ChangeRequest from '@/components/sasisopa/ChangeRequest.vue'
import ChangeRequests from '@/components/sasisopa/ChangeRequests.vue'
import ChangeRequests_user from '@/components/sasisopa/ChangeRequests_user.vue'

const routes = [
  { path: '/Login', component: Login, name: 'Login' },
  { path: '/TPA', component: HomeTPA, name: 'HomeTPA' },
  { path: '/Admin', component: HomeAdmin, name: 'HomeAdmin' },
  { path: '/IRGE', component: HomeIRGE, name: 'HomeIRGE' },
  { path: '/HomeGia', component: HomeGia, name: 'HomeGia' },
  { path: '/Corporativo', component: HomeCorp, name: 'HomeCorp' },
  { path: '/Directorio', component: Directorio, name: 'Directorio' },
  { path: '/ducterTube', component: DucterTube, name: 'DucterTube' },
  { path: '/ducterTube/Nuevo', component: DucterTube_Nuevo, name: 'DucterTube_Nuevo' },
  { path: '/TPA/SCA/Documentacion', component: HomeDocumentacionTPA, name: 'HomeDocumentacionTPA' },
  { path: '/TPA/SCA/Documentacion/Nuevo', component: DocumentarTpa, name: 'DocumentarTpa' },
  { path: '/TPA/SCA/Documentacion/Buscar', component: BusquedasTpa, name: 'BusquedasTpa' },
  { path: '/TPA/SCA/Documentacion/Reportes', component: ReportesTpa, name: 'ReportesTpa' },
  { path: '/TPA/SCA/Documentacion/Configuracion', component: ConfiguracionTpa, name: 'ConfiguracionTpa' },
  { path: '/TPA/SCA/Documentacion/Editar', component: EditarEmbarqueTpa, name: 'EditarEmbarqueTpa' },
  { path: '/TPA/SCA/Documentacion/Entradas', component: EntradasTpa, name: 'EntradasTpa' },

  { path: '/IRGE/SCA/Documentacion', component: HomeDocumentacionIRGE, name: 'HomeDocumentacionIRGE' },
  { path: '/IRGE/SCA/Documentacion/Nuevo', component: DocumentarIrge, name: 'DocumentarIrge' },
  { path: '/IRGE/SCA/Documentacion/Buscar', component: BusquedasIrge, name: 'BusquedasIrge' },
  { path: '/IRGE/SCA/Documentacion/Reportes', component: ReportesIrge, name: 'ReportesIrge' },
  { path: '/IRGE/SCA/Documentacion/Configuracion', component: ConfiguracionIrge, name: 'ConfiguracionIrge' },
  { path: '/IRGE/SCA/Documentacion/Editar', component: EditarEmbarqueIrge, name: 'EditarEmbarqueIrge' },
  { path: '/IRGE/SCA/Documentacion/Entradas', component: EntradasIrge, name: 'EntradasIrge' },

  { path: '/Almacenes', component: ListaAlmacenes, name: 'ListaAlmacenes' },
  { path: '/Inventario', component: Menu, name: 'Menu' },
  { path: '/Inventario/Almacen', component: MenuAlmacen, name: 'MenuAlmacen' },
  { path: '/Inventario/Almacen/Entradas', component: SubMenuEntradas, name: 'SubMenuEntradas' },
  { path: '/Inventario/Almacen/Salidas', component: SubMenuSalidas, name: 'SubMenuSalidas' },
  { path: '/Inventario/Almacenes', component: SubMenuAlmacen, name: 'SubMenuAlmacen' },
  { path: '/Inventario/Almacen/Articulos', component: ListaArticulos, name: 'ListaArticulos' },
  { path: '/Inventario/Almacen/Cede', component: ListaArticulosCede, name: 'ListaArticulosCede' },
  { path: '/Inventario/Almacen/Consumibles', component: ContainerConsumibles, name: 'ContainerConsumibles' },
  { path: '/Inventario/Almacen/Altas', component: Altas, name: 'Altas' },
  { path: '/Inventario/Almacen/Alta/Detalle/:id', component: AltaDetalle, name: 'AltaDetalle' },
  { path: '/Inventario/Almacen/AltaNueva', component: AltaNueva, name: 'AltaNueva' },
  { path: '/Inventario/Salidas', component: SalidasInv, name: 'SalidasInv' },
  { path: '/Inventario/SalidaNueva', component: SalidaNueva, name: 'SalidaNueva' },
  { path: '/Inventario/Asignacion/Detalle', component: AsignacionDetalle, name: 'AsignacionDetalle' },
  { path: '/Inventario/Asignacion/Firma', component: FirmarAsignacion, name: 'FirmarAsignacion' },
  { path: '/Inventario/Asignacion/SubMenu', component: SubMenuAsignaciones, name: 'SubMenuAsignaciones' },
  { path: '/Inventario/ListaSalida', component: ListaSalida, name: 'ListaSalida' },
  { path: '/Inventario/Salida/Detalle', component: SalidaDetalle, name: 'SalidaDetalle' },
  { path: '/Inventario/Salida/Firma', component: FirmarSalida, name: 'FirmarSalida' },
  { path: '/Inventario/Asignaciones', component: Asignaciones, name: 'Asignaciones' },
  { path: '/Inventario/NuevaAsignacion', component: NuevaAsignacion, name: 'NuevaAsignacion' },
  { path: '/Inventario/Busqueda', component: Busqueda, name: 'Busqueda' },
  { path: '/Inventario/Salida/Busqueda', component: BusquedaSalidas, name: 'BusquedaSalidas' },
  { path: '/Inventario/Busqueda/Avanzada', component: BusquedaAvanzada, name: 'BusquedaAvanzada' },
  { path: '/Inventario/Buscar', component: Buscar, name: 'Buscar' },
  { path: '/Inventario/Categorias', component: Tipos, name: 'Tipos' },
  { path: '/Inventario/Marcas', component: Marcas, name: 'Marcas' },
  { path: '/Inventario/Tags', component: Tags, name: 'Tags' },
  { path: '/Inventario/Empleados', component: Empleados, name: 'Empleados' },
  { path: '/Inventario/ArticuloDetalle/:id', component: ArticuloDetalle, name: 'ArticuloDetalle' },
  { path: '/Inventario/Alta', component: NuevoArticulo, name: 'NuevoArticulo' },
  { path: '/Inventario/Resguardos/:id', component: Resguardos, name: 'Resguardos' },
  { path: '/Inventario/Historia/:id', component: Historia, name: 'Historia' },
  { path: '/Inventario/Numero/:id', component: HistoriaNumero, name: 'HistoriaNumero' },
  { path: '/Inventario/Consumibles', component: Consumibles, name: 'Consumibles' },
  { path: '/Inventario/Consumibles/Nuevo', component: NuevoConsumible, name: 'NuevoConsumible' },
  { path: '/Inventario/Consumibles/Agregar', component: UpdateConsumible, name: 'UpdateConsumible' },
  { path: '/Inventario/Consumibles/Salidas', component: ContainerSalida_Cons, name: 'ContainerSalida_Cons' },
  { path: '/Inventario/Consumibles/Reingreso', component: ContainerReingreso_Cons, name: 'ContainerReingreso_Cons' },
  { path: '/Inventario/Consumibles/Detalle', component: ConsumibleDetalle, name: 'ConsumibleDetalle' },
  { path: '/Inventario/Consumibles/Firmar', component: ConsumiblesFirmar, name: 'ConsumiblesFirmar' },
  { path: '/Inventario/Cedes/Consumibles', component: ConsumiblesCedes, name: 'ConsumiblesCedes' },
  { path: '/Inventario/Reasignaciones', component: Reasignaciones, name: 'Reasignaciones' },
  { path: '/Inventario/Reasignacion/Nueva', component: NewReasignacion, name: 'NuevaReasignacion' },
  { path: '/Inventario/Reasignar', component: Reasignar, name: 'Reasignar' },
  { path: '/Inventario/Prestamos', component: Prestamos, name: 'Prestamos' },
  { path: '/Inventario/Prestamos/Nuevo', component: NuevoPrestamo, name: 'NuevoPrestamo' },
  { path: '/Inventario/Prestamos/Firma', component: FirmarPrestamo, name: 'FirmarPrestamo' },
  { path: '/Inventario/Prestamos/Detalle', component: PrestamoDetalle, name: 'PrestamoDetalle' },
  { path: '/Inventario/Articulos', component: BaseArticulos, name: 'BaseArticulos' },
  { path: '/Inventario/Articulos/Nuevo', component: NuevoArticulo_Base, name: 'NuevoArticulo_Base' },
  { path: '/Inventario/Administracion', component: SubMenuAdmon, name: 'SubMenuAdmon' },
  { path: '/Inventario/Descargas', component: DescargasAsinaciones, name: 'DescargasAsinaciones' },
  { path: '/Inventario/Maquinaria/', component: ContainerMaquinaria, name: 'ContainerMaquinaria' },
  { path: '/Inventario/Sistemas/Menu/', component: SubMenuSistemas, name: 'SubMenuSistemas' },
  { path: '/Inventario/Sistemas/Almacenes/', component: ContainerAlmacenes, name: 'ContainerAlmacenes' },
  { path: '/Inventario/Almacen/Traspasos/', component: Traspasos, name: 'Traspasos' },
  { path: '/Inventario/Almacen/Asignaciones/', component: ListaAsignaciones, name: 'ListaAsignaciones' },
  { path: '/Inventario/Almacen/Prestamos/', component: ListaPrestamos, name: 'ListaPrestamos' },
  { path: '/Inventario/Almacen/Bajas/Nueva', component: BajaArticulo, name: 'BajaArticulo' },
  { path: '/Inventario/Almacen/Bajas/Firma', component: FirmarBaja, name: 'FirmarBaja' },
  { path: '/Inventario/Almacen/Bajas', component: Bajas, name: 'Bajas' },

  { path: '/Asistentes/Facturas', component: FacturasAsistentes, name: 'FacturasAsistentes' },
  { path: '/Factura/Alta', component: NuevaFactura, name: 'NuevaFactura' },

  { path: '/Soporte', component: Soporte, name: 'Soporte' },
  { path: '/Soporte/Nuevo', component: NuevoTicket, name: 'NuevoTicket' },
  { path: '/Soporte/Detalle', component: DetalleTicket, name: 'DetalleTicket' },
  { path: '/Soporte/Atencion', component: AtenderTicket, name: 'Atender' },


  { path: '/Externo', component: HomeGrupos, name: 'HomeGrupos' },
  { path: '/Grupos/TPA/Facturas/Nueva', component: NewFacturaTPA, name: 'NewFacturaTPA' },
  { path: '/Grupos/TPA/Facturas', component: FacturasTPA, name: 'FacturasTPA' },
  { path: '/Grupos/TPA/Documentados', component: CargasGruposTPA, name: 'CargasGruposTPA' },
  { path: '/Grupos/IRGE/Facturas/Nueva', component: NewFacturaIRGE, name: 'NewFacturaIRGE' },
  { path: '/Grupos/IRGE/Facturas', component: FacturasIRGE, name: 'FacturasIRGE' },
  { path: '/Grupos/IRGE/Documentados', component: CargasGruposIRGE, name: 'CargasGruposIRGE' },

  { path: '/Monitor', component: Monitor, name: 'Monitor' },
  { path: '/Monitor/Valvulas', component: valvulas, name: 'valvulas' },
  { path: '/Monitor/Reportes', component: Reportes, name: 'Reportes' },
  { path: '/Estacion', component: Estacion, name: 'Estacion' },
  { path: '/Planificacion', component: HomePlanificacion, name: 'HomePlanificacion' },
  { path: '/Resumen', component: HomeResumen, name: 'HomeResumen' },
  { path: '/Checklist', component: HomeChecklist, name: 'HomeChecklist' },
  { path: '/Checklist/Historia/:id', component: Historia_Checklist, name: 'Historia_Checklist' },
  { path: '/Solicitudes', component: HomeSolicitudes, name: 'HomeSolicitudes' },
  { path: '/Solicitudes/Nueva', component: NuevaSolicitud, name: 'NuevaSolicitud' },
  { path: '/Usuarios', component: HomeUsuarios, name: 'HomeUsuarios' },
  { path: '/Usuario/Nuevo', component: UsuarioNuevo, name: 'UsuarioNuevo' },
  { path: '/Usuario/Detalle/:id', component: UsuarioDetalle, name: 'UsuarioDetalle' },
  { path: '/Usuario/Permisos', component: Permisos, name: 'Permisos' },
  { path: '/Usuario/Permisos/Nuevo', component: PermisosNuevos, name: 'PermisosNuevos' },
  { path: '/Compras-Solicitudes', component: HomeComprasReq, name: 'HomeComprasReq' },
  { path: '/Compras-Solicitudes/Menu', component: MenuComprasReq, name: 'MenuComprasReq' },

  { path: '/CajaChica', component: HomeCajaChica, name: 'HomeCajaChica' },
  { path: '/PartidaNoPresupuestada', component: HomePartidaNoPres, name: 'HomePartidaNoPres' },

  { path: '/Requisiciones', component: Requisiciones, name: 'Requisiciones' },
  { path: '/Requisiciones/Nueva', component: RequisicionNueva, name: 'RequisicionNueva' },
  { path: '/Requisiciones/Editar', component: RequisicionEditar, name: 'RequisicionEditar' },
  { path: '/Requisiciones/Firma', component: FormFirma, name: 'FormFirma' },
  { path: '/Requisiciones/Proveedores', component: Proveedores, name: 'Proveedores' },
  { path: '/Requisiciones/Proveedores/Nuevo', component: NuevoProveedor, name: 'NuevoProveedor' },
  { path: '/Cotizaciones/', component: HomeCotizaciones, name: 'HomeCotizaciones' },
  { path: '/Cotizaciones/Nueva', component: CotizacionNueva, name: 'CotizacionNueva' },

  { path: '/Presupuestos/', component: HomePresupuestos, name: 'HomePresupuestos' },
  { path: '/Presupuestos/Nuevo', component: PresupuestoNuevo, name: 'PresupuestoNuevo' },

  { path: '/Responsivas', component: Responsivas, name: 'Responsivas' },
  { path: '/Responsivas/Nueva', component: NuevaResponsiva, name: 'NuevaResponsiva' },
  { path: '/Responsivas/Editar', component: EditarResponsiva, name: 'EditarResponsiva' },
  { path: '/Responsivas/Firma', component: FirmaResponsiva, name: 'FirmaResponsiva' },

  { path: '/Transportes/Combustible/Asignaciones', component: Combu_Asignaciones, name: 'Combu_Asignaciones' },
  { path: '/Transportes/Combustible/Salidas', component: Combu_Salidas, name: 'Salidas' },
  { path: '/Transportes/Combustible/Asignacion/Nueva', component: Combu_NewAsignacion, name: 'Combu_NewAsignacion' },
  { path: '/Transportes/Combustible/Salidas/Nueva', component: Combu_NewSalida, name: 'NuevaSalida' },
  { path: '/Transportes/Combustible/Salidas/Editar', component: Combu_EditarSalida, name: 'Combu_EditarSalida' },
  { path: '/Transportes/Combustible/Saldo', component: Combu_Saldo, name: 'Combu_Saldo' },
  { path: '/Transportes/Combustible/Resumen', component: Combu_Resumen, name: 'Combu_Resumen' },
  { path: '/Transportes/Combustible/Resumen/Nuevo', component: Combu_NewResumen, name: 'Combu_NewResumen' },
  { path: '/Transportes/Combustible/Resumen/Firma', component: Combu_FirmaReporteMensual, name: 'Combu_FirmaReporteMensual' },
  { path: '/Transportes/Combustible/Traspasos', component: Combu_Traspasos, name: 'Combu_Traspasos' },
  { path: '/Transportes/Combustible/Traspasos/Nuevo', component: Combu_NewTraspaso, name: 'Combu_NewTraspaso' },
  { path: '/Transportes', component: HomeTransportes, name: 'HomeTransportes' },
  { path: '/Transportes/Combustible', component: HomeCombustibles, name: 'HomeCombustibles' },

  { path: '/Transportes/Tarjetas', component: HomeTarjetas, name: 'HomeTarjetas' },
  { path: '/Transportes/Tarjetas/Movimientos', component: TarjetasMovimientos, name: 'TarjetasMovimientos' },
  { path: '/Transportes/Tarjetas/Movimientos/Nuevo', component: Combu_TarjetasNuevo, name: 'Combu_TarjetasNuevo' },
  { path: '/Transportes/Tarjetas/Comercios', component: TarjetasComercios, name: 'TarjetasComercios' },
  { path: '/Transportes/Tarjetas/Comercios/Nuevo', component: ComercioNuevo, name: 'ComercioNuevo' },
  { path: '/Transportes/Tarjetas/Movimientos/Importar', component: ImportarTarjetas, name: 'ImportarTarjetas' },

  { path: '/Transportes/Tags', component: HomeTags, name: 'HomeTags' },
  { path: '/Transportes/Tags/Movimientos', component: TagsMovimientos, name: 'TagsMovimientos' },
  { path: '/Transportes/Tags/Movimientos/Nuevo', component: NewMovimientoTag, name: 'NewMovimientoTag' },
  { path: '/Transportes/Tags/Cruces', component: TagsCruces, name: 'TagsCruces' },
  { path: '/Transportes/Tags/Cruces/Nuevo', component: CruceNuevo, name: 'CruceNuevo' },
  { path: '/Transportes/Tags/Movimientos/Importar', component: ImportarTags, name: 'ImportarTags' },

  { path: '/Transportes/Vehiculos', component: HomeVehiculos, name: 'HomeVehiculos' },
  { path: '/Transportes/Vehiculos/Unidades', component: Vehiculo_Unidades, name: 'Vehiculo_Unidades' },
  { path: '/Transportes/Vehiculos/Nuevo', component: Combu_NuevoVehiculo, name: 'Combu_NuevoVehiculo' },
  { path: '/Documentacion', component: HomeDocumentacionApp, name: 'HomeDocumentacionApp' },
  { path: '/GerenciaAdmin', component: HomeGA, name: 'HomeGA' },
  { path: '/Ducto', component: HomeDucto, name: 'HomeDucto' },
  { path: '/SoporteGIA', component: HomeGIA_S, name: 'HomeGIA_S' },
  { path: '/Almacenista', component: HomeGIA_A, name: 'HomeGIA_A' },
  { path: '/Asistentes', component: HomeAsistentes, name: 'HomeAsistentes' },
  { path: '/Auditoria', component: HomeAuditoria, name: 'HomeAuditoria' },
  { path: '/Codigos/:id', component: CodigosQR_Home, name: 'CodigosQR_Home' },
  { path: '/Codigos/Registro/:id', component: CodigosQR_Registro, name: 'CodigosQR_Registro' },
  { path: '/Proveedores/', component: ProveedoresPendientes, name: 'ProveedoresPendientes' },
  { path: '/Proveedores/Editar', component: ProveedoresPendientesEditar, name: 'ProveedoresPendientesEditar' },
  { path: '/IRGE/SCA/', component: MenuIRGE, name: 'MenuIRGE' },
  { path: '/IRGE/SCA/Nominaciones', component: HomeNominacionesIRGE, name: 'HomeNominacionesIRGE' },
  { path: '/IRGE/SCA/CuartoControl', component: HomeCuartoControlIRGE, name: 'HomeCuartoControlIRGE' },
  { path: '/IRGE/SCA/Accesos', component: HomeAccesosIRGE, name: 'HomeAccesosIRGE' },
  { path: '/IRGE/SCA/Accesos/Registrar', component: NuevoAccesosIRGE, name: 'NuevoAccesosIRGE' },
  { path: '/IRGE/SCA/Accesos/Editar', component: UpdateAccesosIRGE, name: 'UpdateAccesosIRGE' },
  { path: '/IRGE/SCA/Bascula', component: BasculaIRGE, name: 'BasculaIRGE' },
  { path: '/IRGE/SCA/Bitacora', component: BitacoraIRGE, name: 'BitacoraIRGE' },
  { path: '/IRGE/SCA/Dashboard', component: DashboardIRGE, name: 'DashboardIRGE' },
  { path: '/IRGE/SCA/Consumos', component: ConsumosIRGE, name: 'ConsumosIRGE' },
  { path: '/TPA/SCA', component: MenuTPA, name: 'MenuTPA' },
  { path: '/TPA/SCA/Nominaciones', component: HomeNominacionesTPA, name: 'HomeNominacionesTPA' },
  { path: '/TPA/SCA/CuartoControl', component: HomeCuartoControlTPA, name: 'HomeCuartoControlTPA' },
  { path: '/TPA/SCA/Accesos', component: HomeAccesosTPA, name: 'HomeAccesosTPA' },
  { path: '/TPA/SCA/Accesos/Registrar', component: NuevoAccesosTPA, name: 'NuevoAccesosTPA' },
  { path: '/TPA/SCA/Accesos/Editar', component: UpdateAccesosTPA, name: 'UpdateAccesosTPA' },
  { path: '/TPA/SCA/Bascula', component: BasculaTPA, name: 'BasculaTPA' },
  { path: '/TPA/SCA/Bitacora', component: BitacoraTPA, name: 'BitacoraTPA' },
  { path: '/TPA/SCA/Dashboard', component: DashboardTPA, name: 'DashboardTPA' },
  { path: '/TPA/SCA/Consumos', component: ConsumosTPA, name: 'ConsumosTPA' },
  { path: '/TPA/SCA/Grupos', component: GruposTPA, name: 'GruposTPA' },
  { path: '/TPA/SCA/EditarSubgrupoTPA', component: EditarSubgrupoTPA, name: 'EditarSubgrupoTPA' },
  { path: '/TPA/SCA/Subgrupos', component: SubgrupoTPA, name: 'SubgrupoTPA' },
  { path: '/IRGE/SCA/Grupos', component: GruposIRGE, name: 'GruposIRGE' },
  { path: '/IRGE/SCA/EditarSubgrupoIRGE', component: EditarSubgrupoIRGE, name: 'EditarSubgrupoIRGE' },
  { path: '/IRGE/SCA/Subgrupos', component: SubgrupoIRGE, name: 'SubgrupoIRGE' },
  { path: '/Visitas/Corpo/', component: VisitasCorpoHome, name: 'VisitasCorpoHome' },
  { path: '/Visitas/Corpo/Registros', component: VisitasCorpo, name: 'VisitasCorpo' },
  { path: '/Visitas/Corpo/Nuevo', component: VisitasCorpoRegistrar, name: 'VisitasCorpoRegistrar' },
  { path: '/Visitas/Corpo/Firma', component: VisitasCorpoFirmar, name: 'VisitasCorpoFirmar' },
  { path: '/Visitas/Corpo/Reportes', component: VisitasCorpoReportes, name: 'VisitasCorpoReportes' },

  { path: '/Apartado/Activos', component: ApartadoActivos, name: 'ApartadoActivos' },
  { path: '/Apartado/Auditoria', component: ApartadoAuditoria, name: 'ApartadoAuditoria' },
  { path: '/Apartado/DUCTO', component: ApartadoDucto, name: 'ApartadoDucto' },
  { path: '/Apartado/GIA', component: ApartadoGIA, name: 'ApartadoGIA' },
  { path: '/Apartado/IRGE', component: ApartadoIRGE, name: 'ApartadoIRGE' },
  { path: '/Apartado/TPA', component: ApartadoTPA, name: 'ApartadoTPA' },
  { path: '/Apartado/CORPO', component: ApartadoCORPO, name: 'ApartadoCORPO' },
  { path: '/Apartado/RH', component: ApartadoRH, name: 'ApartadoRH' },
  { path: '/Apartado/SASISOPA', component: ApartadoSASISOPA, name: 'ApartadoSASISOPA' },
  { path: '/', component: Landing, name: 'Landing' },
  { path: '/passwords/Generador', component: GeneradorPasswords, name: 'GeneradorPasswords' },

  { path: '/Apartado/SASISOPA/terminal', component: AddTerminalSASISOPA, name: 'AddTerminalSASISOPA' },
  { path: '/Apartado/SASISOPA/documentos/:id/editar', component: EditTerminalSASISOPA, name: 'EditTerminalSASISOPA' },
  { path: '/SASISOPA/documentos/:id', component: DocumentsSASISOPA, name: 'DocumentsSASISOPA' },
  { path: '/SASISOPA/documentos/:id_terminal/:id/editar', component: EditDocumentSASISOPA, name: 'EdtDocumentSASISOPA' },
  { path: '/SASISOPA/ambitos/:terminal_id/:id', component: AmbitSASISOPA, name: 'AmbitSASISOPA' },
  { path: '/SASISOPA/ambitos/:terminal_id/:id/agregar', component: AddAmbitSASISOPA, name: 'AddAmbitSASISOPA' },
  { path: '/SASISOPA/ambito/:id_terminal/:document_id/:id/editar', component: EditAmbitSASISOPA, name: 'EditAmbitSASISOPA' },
  { path: '/SASISOPA/archivos/:terminal_id/:document_id/:id', component: FilesSASISOPA, name: 'FilesSASISOPA' },
  { path: '/SASISOPA/archivos/:id/agregar', component: AddDocumentSASISOPA, name: 'AddDocumentSASISOPA' },
  { path: '/SASISOPA/archivo/:id', component: FileSASISOPA, name: 'FileSASISOPA' },
  { path: '/SASISOPA/logs/', component: logs, name: 'logs' },
  { path: '/SASISOPA/solicitud-cambio/:id', component: ChangeRequest, name: 'ChangeRequest' },
  { path: '/SASISOPA/solicitudes-cambio', component: ChangeRequests, name: 'ChangeRequests' },
  { path: '/SASISOPA/mis-solicitudes-cambio', component: ChangeRequests_user, name: 'ChangeRequests_user' },

  { path: '/ExpedienteDescarga', component: ExpedienteDescarga, name: 'ExpedienteDescarga' },
  { path: '/ConsultaHistorica', component: ConsultaHistorica, name: 'ConsultaHistorica' },
  { path: '/ConsultaHistorica/BT', component: ListadoConsultaHistorica, name: 'ListadoConsultaHistorica' },
  { path: '/ConsultaHistorica/BT/Archivos', component: ListadoArchivos, name: 'ListadoArchivos' },
]

export default routes




// WEBPACK FOOTER //
// ./src/routes.js